const ExtraDelay = 1;

export const UxMetrics = {
  LoadingFade: 600 * ExtraDelay,
  LoadingScoreDuration: 1500 * ExtraDelay,
  LoadingScoreDelay: 500 * ExtraDelay,
  LoadingScoreRepeat: 500 * ExtraDelay,

  CardFlipDelay: 150 * ExtraDelay,
  CardClearDelay: 350 * ExtraDelay,

  CardDealDuration: 10 * ExtraDelay,
  CardDealTravelDuration: 450 * ExtraDelay,
  ScoreFadeDuration: 75 * ExtraDelay,

  CardOpenDeckDuration: 450 * ExtraDelay,
  CardOpenNextDuration: 350 * ExtraDelay,
  CardRemoveCurrentDuration: 150 * ExtraDelay,

  CardStackDuration: 200 * ExtraDelay,
  CardBounceDuration: 40 * ExtraDelay,
  CardStackDropDelay: 150 * ExtraDelay,

  ColumnFlashIn: 30 * ExtraDelay,
  ColumnFlashOut: 800 * ExtraDelay,

  ChevronFlashDuration: 120 * ExtraDelay,
  ChevronHideDuration: 50 * ExtraDelay,

  BonusFadeDuration: 300 * ExtraDelay,
  BonusTravelDuration: 750 * ExtraDelay,
  BonusClearDelay: 500 * ExtraDelay,
};
